export default __webpack_public_path__ + "static/media/candidate-def.86edc105.svg";